export default "__VITE_ASSET__W7lqF90a__"